import React from "react";
import "./QuestionCards.css";

const QuestionCards = ({ isChecked, cardValue, isInError }) => {
  return (
    <div
      className={
        "question_single_card" + (isChecked ? " question_card_active " : "") + (isInError ? " container_error" : "")
      }
    >
      {cardValue}
    </div>
  );
};

export default QuestionCards;
